var React = require('react');

function NextEnabled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.482 0L0 1.38 6.036 7 0 12.62 1.482 14 9 7z","fillRule":"evenodd"}));
}

NextEnabled.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14"};

module.exports = NextEnabled;

NextEnabled.default = NextEnabled;
